import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import {
  BASE_URL,
  GET_MANAGE_GROUPS,
  GET_MANAGE_PERMISSION,
  PERMISSION_ADDUPDATE,
  PERMISSION_MODULES,
  SELECT_PERMISSION_LEVEL,
  GET_COMPANY_GROUP,
  GET_PERMISSION_DATA,
  GET_GROUP_DATA,
  GET_USERS_IN_Group,
  GET_USERS_IN_GROUP,
} from "../constants";
import customBaseQuery from "../CustomBaseQuery/customBaseQuery";
import { getUserToken } from "../utilityFunctions/localServices";

export const managePermissions = createApi({
  reducerPath: "managePermissions",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchPermissionTableData: builder.query({
      query: ({ token, pagination, locationFlag }) => {
        const params = new URLSearchParams({
          ...pagination,
        });
        const storedData = localStorage.getItem("company_data");
        const companyId = JSON.parse(storedData);
        const id = companyId.company_id;
        const companyUrl = `${GET_COMPANY_GROUP}${id}`;

        const baseUrl = locationFlag ? companyUrl : GET_MANAGE_PERMISSION;
        const url = `${baseUrl}?${params.toString()}`;
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
    fetchPermissionTableDataNode: builder.query({
      query: ({ token, params }) => {
        const queryParams = new URLSearchParams({
          ...params,
        }).toString();

        return {
          url: `${GET_PERMISSION_DATA}?${queryParams}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
    fetchGroupTableDataNode: builder.query({
      query: ({ token, params }) => {
        const queryParams = new URLSearchParams({
          ...params,
        }).toString();

        return {
          url: `${GET_GROUP_DATA}?${queryParams}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
    fetchUsersInGroupTableDataNode: builder.query({
      query: ({ token, params }) => {
        const queryParams = new URLSearchParams({
          ...params,
        }).toString();

        return {
          url: `${GET_USERS_IN_GROUP}?${queryParams}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
  }),
});

export const {
  useFetchPermissionTableDataQuery,
  useFetchPermissionTableDataNodeQuery,
  useFetchGroupTableDataNodeQuery,
  useFetchUsersInGroupTableDataNodeQuery,
  useLazyFetchUsersInGroupTableDataNodeQuery,
} = managePermissions;

export const PermissionsAddUpdate = createApi({
  reducerPath: "PermissionsAddUpdate",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    PermissionsAddUpdate: builder.mutation({
      query: ({ token, data }) => ({
        url: `${PERMISSION_ADDUPDATE}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
    }),
  }),
});

export const { usePermissionsAddUpdateMutation } = PermissionsAddUpdate;

export const selectPermission = createApi({
  reducerPath: "selectPermission",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchSelectPermission: builder.query({
      query: (token) => {
        const url = `${SELECT_PERMISSION_LEVEL}`;
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
  }),
});

export const { useFetchSelectPermissionQuery } = selectPermission;

export const PermissionModule = createApi({
  reducerPath: "PermissionModule",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchPermissionModule: builder.query({
      query: ({ token, id }) => {
        const url = id ? `${PERMISSION_MODULES}?id=${id}` : PERMISSION_MODULES;
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
  }),
});

export const { useFetchPermissionModuleQuery, useLazyFetchPermissionModuleQuery } = PermissionModule;

export const manageCompanyGroup = createApi({
  reducerPath: "manageCompanyGroup",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    fetchPermissionTableData: builder.query({
      query: ({ token, pagination }) => {
        const params = new URLSearchParams({
          ...pagination,
        });

        const url = `${GET_COMPANY_GROUP}?${params.toString()}`;
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
  }),
});

export const { useFetchCustomerPermissionTableDataQuery } = manageCompanyGroup;
